/**
 * 解析 query
 *
 * @param name - 可选参数，若为空则返回全部 query; 否则只返回对应 name 的 query 值
 * @param search - 可选参数
 * @example
 */
export default function getQuery(name?: string, searchInfo?: string) {
  let search = searchInfo;

  if (typeof window !== 'undefined' && !search) {
    search = window.location?.search.substr(1);
  }

  const queries: { [key: string]: any } = {};

  if (typeof search === 'string') {
    search.split('&').forEach((c) => {
      if (c === '') {
        return;
      }

      const [key, value = ''] = c.split('=');

      queries[decodeURIComponent(key)] = value === '' ? true : decodeURIComponent(value);
    });
  }

  return name ? queries[name] : queries;
}
